var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyOrdo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.37,
    height: 42.37,
    viewBox: "0 0 42.37 42.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements",
    transform: "translate(-1.9 -1.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    fill: "#f5333f",
    d: "M23.1 1.56a21.185 21.185 0 1 0 21.17 21.177A21.185 21.185 0 0 0 23.1 1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    d: "M15.559 26.454a2.244 2.244 0 1 1 0-4.45 2.231 2.231 0 1 1 0 4.424z",
    className: "cls-2",
    transform: "translate(3.141 5.768)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    d: "M22.476 26.448a2.231 2.231 0 1 1 0-4.424 2.231 2.231 0 1 1 0 4.424z",
    className: "cls-2",
    transform: "translate(5.098 5.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    d: "M15.891 20.518a4.77 4.77 0 0 1 4.8-5.13 4.822 4.822 0 0 1 4.809 5.13 5.514 5.514 0 0 1-.372 2.052h5.652a9.977 9.977 0 0 0 .22-2.065 9.823 9.823 0 0 0-10.259-9.823c-6.143 0-10.349 4.386-10.349 9.823a9.977 9.977 0 0 0 .231 2.129H16.3a5.514 5.514 0 0 1-.41-2.116z",
    className: "cls-2",
    transform: "translate(2.397 2.573)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyOrdo);
export default __webpack_public_path__ + "static/media/my-ordo.3d039029e1d6661288ae0d1ea18c3d5b.svg";
export { ForwardRef as ReactComponent };